<template>
  <v-dialog
      v-model="open"
      width="90vw"
      max-width="900px"
      overlay-opacity="0.9"
      persistent
  >
    <v-card class="view">
      <v-container style="height:70vh;overflow: auto">
        <v-row>
          <v-col>
            <Avatar v-for="sale in sales_PJ.filter(s=>s.enabled)" :active="sale.employee_code!==null && current_sales_key[sale.employee_code]"
                    :user="sale"
                    class="clickable"
                    @click.native="onClick(sale.employee_code)"></Avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Avatar v-for="sale in sales_TT.filter(s=>s.enabled)" :active="sale.employee_code!==null && current_sales_key[sale.employee_code]"
                    :user="sale"
                    class="clickable"
                    @click.native="onClick(sale.employee_code)"></Avatar>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <Avatar v-for="sale in sales_MT.filter(s=>s.enabled)" :active="sale.employee_code!==null && current_sales_key[sale.employee_code]"
                    :user="sale"
                    class="clickable"
                    @click.native="onClick(sale.employee_code)"></Avatar>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <Avatar v-for="sale in sales_ON.filter(s=>s.enabled)" :active="sale.employee_code!==null && current_sales_key[sale.employee_code]"
                    :user="sale"
                    class="clickable"
                    @click.native="onClick(sale.employee_code)"></Avatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <Avatar v-for="sale in sales_FT.filter(s=>s.enabled)" :active="sale.employee_code!==null && current_sales_key[sale.employee_code]"
                    :user="sale"
                    class="clickable"
                    @click.native="onClick(sale.employee_code)"></Avatar>
          </v-col>
        </v-row>


      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-4" color="gray" text @click="onCancel()">
          ยกเลิก
        </v-btn>
        <v-btn class="primary" right @click="onOK()">OK</v-btn>
      </v-card-actions>
    </v-card>


  </v-dialog>
</template>
<style lang="scss" scoped>
.view {
  position: relative;
  /*background: #FF0000;*/
}


</style>

<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'
import Avatar from '../components/User/Avatar.vue'
import {Product} from '../models/Product'
import {User} from '../models/User'


@Component({
  components: {
    Avatar,
  },
})
export default class SalesDialog extends Vue {

  open = false
  current_sales: User[] = []
  current_sales_key = {}
  init_value = ''

  get sales_PJ() {
    if (!this.$store.state.users || !this.$store.state.users.data) {
      return []
    }
    return this.$store.state.users.data.filter(user => user.department == 'PJ')
  }

  get sales_TT() {
    if (!this.$store.state.users || !this.$store.state.users.data) {
      return []
    }
    return this.$store.state.users.data.filter(user => user.department == 'TT')
  }

  get sales_MT() {
    if (!this.$store.state.users || !this.$store.state.users.data) {
      return []
    }
    return this.$store.state.users.data.filter(user => user.department == 'MT')
  }

  get sales_ON() {
    if (!this.$store.state.users || !this.$store.state.users.data) {
      return []
    }
    return this.$store.state.users.data.filter(user => user.department == 'ON' || user.department == 'OL')
  }

  get sales_FT() {
    if (!this.$store.state.users || !this.$store.state.users.data) {
      return []
    }
    return this.$store.state.users.data.filter(user => user.department == 'FT')
  }

  onClick(code) {
    if (this.current_sales_key[code]) {
      delete this.current_sales_key[code]
    } else {
      this.current_sales_key[code] = true
    }

    this.current_sales_key = {...this.current_sales_key}
  }

  onApply: Function = () => {

  }

  onOpen({sales, onApply}) {
    // console.log('sales mounted')
    this.current_sales_key = {}
    this.current_sales = sales
    for (let i in this.current_sales) {
      let sale = this.current_sales[i]
      if (sale.employee_code) {
        this.current_sales_key[sale.employee_code] = true
      }
    }
    this.init_value = JSON.stringify(Object.keys(this.current_sales_key))
    this.onApply = onApply
    this.open = true
  }

  onOK() {
    const diff_value = JSON.stringify(Object.keys(this.current_sales_key))

    if (this.init_value == diff_value) {
      this.open = false
      return
    }

    let sales = Object.keys(this.current_sales_key).map(code => {
      return {
        'user_code': code,
      }
    })
    // console.log(sales)
    this.onApply(sales)
    this.open = false
  }

  onCancel() {
    this.open = false
  }

  created() {
    this.$root.$on('openSales', this.onOpen)
  }

  onClickAddCart(product: Product, delta = 1) {
    // if (this.$store.state.carts.current.id) {
    //   this.$store.dispatch('alter_item_to_cart', {product, delta})
    // } else {
    //   router.push('/customer')
    // }
  }
};

</script>
